module.exports = __webpack_public_path__ + "static/media/image_men.874c7c9b.png";